var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app-container"}},[_c('SideMenu',{staticClass:"app-nav"}),_c('div',{staticClass:"app-col"},[_c('Header',{staticClass:"app-header"}),_c('main',{staticClass:"app-main"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }